export default __webpack_public_path__ + "static/media/joker_new.a7cd0ed6.svg";